module.exports = __webpack_public_path__ + "static/media/umer.66596c3a.jpg";